import { Sparkles } from "lucide-react";

export default function Marquee({ t }) {
  const items = t.marquee;
  const groups = ["a", "b"]; // two passes for seamless loop
  return (
    <div className="border-y border-[var(--border)] bg-[var(--primary)] text-white overflow-hidden">
      <div className="py-5 marquee-track">
        {groups.map((g) => (
          <div key={g} className="inline-flex items-center gap-12">
            {items.map((txt) => (
              <span
                key={`${g}-${txt}`}
                className="inline-flex items-center gap-3 text-sm font-semibold tracking-wide"
              >
                <Sparkles className="w-4 h-4 text-[var(--accent)]" />
                {txt}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
